import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import shortid from 'shortid';
import Box from '@rsos/components/capstone/base/Box';
import { DefaultTypeArray } from '@rsos/ellington';
import { StyledButton, StyledCollapsibleItem } from './CustomList.styles';
import { trackClickViewMore } from './ellingtonCardTrackings';

const ToggleButton = ({ isActive = false, onClick = () => {} }) => {
  return (
    <Box p={3} pt={0} pb={0} mb={3}>
      <StyledButton onClick={onClick}>
        {isActive ? 'Hide' : 'View More'}
      </StyledButton>
    </Box>
  );
};

const CollapsibleItem = ({
  className,
  maxItems = 4,
  children: reactChildren,
}) => {
  const { irpVersion } = useSelector(state => state.sinatra.irp);
  const [collapsed, setCollapsed] = useState(true);

  const children = reactChildren.filter(c => {
    if (c?.type?.length) {
      return c;
    }
  });

  if (children.length && children.length <= maxItems) {
    return (
      <StyledCollapsibleItem className={className}>
        {children}
      </StyledCollapsibleItem>
    );
  }

  return (
    <StyledCollapsibleItem className={className}>
      {collapsed ? (
        <>
          {children.slice(0, maxItems)}
          <ToggleButton
            isActive={false}
            onClick={() => {
              setCollapsed(prev => !prev);
              trackClickViewMore(irpVersion);
            }}
          />
        </>
      ) : (
        <>
          {children}
          <ToggleButton isActive onClick={() => setCollapsed(prev => !prev)} />
        </>
      )}
    </StyledCollapsibleItem>
  );
};

const isParentArrayType = (path = []) => {
  let hasParentArray = false;
  for (let value of path) {
    if (Number.isInteger(value)) {
      hasParentArray = true;
      break;
    }
  }
  return hasParentArray;
};

const CustomList = props => {
  const { children = [], displaySchema = {}, schema, path } = props;
  const { format = '' } = displaySchema;
  const isNestedArray = isParentArrayType(path);

  if (format === 'profile-data' && !isNestedArray) {
    return (
      <div className="default-type-array">
        {schema?.title && (
          <div className="default-type-array-title">
            <strong className="default-type-title">{schema.title}</strong>
          </div>
        )}
        <div className="default-type-array-children">
          {children.map(child => (
            <CollapsibleItem
              className="default-type-array-item"
              key={shortid.generate()}
            >
              {child}
            </CollapsibleItem>
          ))}
        </div>
      </div>
    );
  }

  return <DefaultTypeArray {...props} />;
};

export default CustomList;
